<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑用户
            </div>
        </div>
        <div class="dialog_body">
            <el-tabs style="padding: 10px 20px" v-model="activeName">
                <el-tab-pane name="first">
                    <span slot="label"><i class="el-icon-date"></i> 用户信息 </span>

                    <el-form :model="form" ref="formData" v-loading="loading" label-width="120px">
                        <el-form-item label="用户编号">
                            <el-input v-model="form.userNo" placeholder="请输入用户编号"></el-input>
                        </el-form-item>
                        <el-form-item label="用户账号" >
                            <el-input v-model="form.loginName" placeholder="请输入用户账号"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名称" >
                            <el-input v-model="form.userName" placeholder="请输入用户名称"></el-input>
                        </el-form-item>
                        <el-form-item label="用户密码">
                            <el-input v-model="form.loginPwd" placeholder="请输入用户密码,为空只默认为1" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码">
                            <el-input v-model="form.newPwd" placeholder="请输入确认密码" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="用户岗位" >
                            <el-input v-model="form.roleNames" placeholder="请选择一个岗位" readonly clearable>
                                <el-button slot="append" icon="el-icon-plus" style="padding: 10px" @click="selRoleData">选择</el-button>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="部门" required>
                            <selectTree v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                        placeholder="请选择部门"></selectTree>
                        </el-form-item>
                        <el-form-item label="可登录账套">
                            <el-input v-model="form.accountNames" placeholder="请选择可登录账套" readonly clearable>
                                <el-button slot="append" icon="el-icon-plus" style="padding: 10px" @click="selAccountData">选择</el-button>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="手机号">
                            <el-input v-model="form.tel" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱">
                            <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" class="bzClass">
                            <el-input
                                    resize="none"
                                    type="textarea"
                                    placeholder="请输入备注"
                                    v-model="form.remark"
                                    rows="1"
                                    show-word-limit>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="状态" required>
                            <el-select v-model="form.userState" placeholder="请选择用户状态" style="width: 200px">
                                <el-option label="启用" value="0"></el-option>
                                <el-option label="禁用" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div style="text-align: center;padding: 10px 0px 20px 0px">
                        <el-button type="danger" @click="close">取 消</el-button>
                        <el-button type="primary" @click="submitForm">保 存</el-button>
                    </div>

                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label">
                        <i class="el-icon-mobile"></i>  登记和查看权
                    </span>
                    <el-form label-width="120px">
                        <el-form-item label="仓库登记权">
                            <el-input type="textarea" rows="2" style="width: 500px;"
                                      v-model="form.warehouseNoReg" placeholder="请选择仓库登记权">
                            </el-input>
                            <el-button icon="el-icon-plus" @click="selWareHouse(2)" style="padding: 10px"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteWareHouse(2)" style="padding: 10px"></el-button>
                        </el-form-item>
                        <el-form-item label="仓库查看权">
                            <el-input type="textarea" rows="2" style="width: 500px;" v-model="form.warehouseNo" placeholder="请选择仓库查看权">
                            </el-input>
                            <el-button icon="el-icon-plus" @click="selWareHouse(1)" style="padding: 10px"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteWareHouse(1)" style="padding: 10px"></el-button>
                        </el-form-item>
                        <el-form-item label="项目登记权">
                            <el-input type="textarea" rows="2" style="width: 500px;" v-model="form.projectNameReg" placeholder="请选择项目登记权">
                            </el-input>
                            <el-button icon="el-icon-plus" @click="selProject(2)" style="padding: 10px"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteProject(2)" style="padding: 10px"></el-button>
                        </el-form-item>
                        <el-form-item label="项目查看权">
                            <el-input type="textarea" rows="2" style="width: 500px;" v-model="form.projectName" placeholder="请选择项目查看权">
                            </el-input>
                            <el-button icon="el-icon-plus" @click="selProject(1)" style="padding: 10px"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteProject(1)" style="padding: 10px"></el-button>
                        </el-form-item>
                        <el-form-item label="物类权">
                            <el-input type="textarea" rows="2" style="width: 500px;" v-model="form.productTypeName" placeholder="请选择物类权">
                            </el-input>
                            <el-button icon="el-icon-plus" @click="selProductType()" style="padding: 10px"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteProductType()" style="padding: 10px"></el-button>
                        </el-form-item>
                        <el-form-item label="部门查看权">
                            <el-input type="textarea" rows="2" style="width: 500px;" v-model="form.departmentIdsName" placeholder="请选择部门查看权">
                            </el-input>
                            <el-button icon="el-icon-plus" @click="selDepartment()" style="padding: 10px"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteDepartment()" style="padding: 10px"></el-button>
                        </el-form-item>
                    </el-form>
                    <div style="text-align: center;padding: 10px 0px 20px 0px">
                        <el-button type="danger" @click="close">取 消</el-button>
                        <el-button type="primary" @click="submitForm">保 存</el-button>
                    </div>

                </el-tab-pane>
                <el-tab-pane name="third">
                    <span slot="label">
                        <i class="el-icon-setting"></i>  特殊设置
                    </span>
                    <div style="padding-left: 30%;padding-bottom: 20px;margin-top:20px">
                        <el-checkbox v-model="form.otherBillFlag" :checked="form.otherBillFlag==1?true:false"
                                     true-label="1" false-label="0" border>他人账单查看权
                        </el-checkbox>
                    </div>
                    <div style="padding-left: 30%;padding-bottom: 20px">
                        <el-checkbox v-model="form.modifyBillFlag" :checked="form.modifyBillFlag==1?true:false"
                                     true-label="1" false-label="0" border>他人账单修改权
                        </el-checkbox>
                    </div>
                    <div style="padding-left: 30%;padding-bottom: 20px">
                        <el-checkbox v-model="form.priceFlag" :checked="form.priceFlag==1?true:false" true-label="1"
                                     false-label="0" border>单价查看权
                        </el-checkbox>
                    </div>

                    <div style="text-align: center;padding: 10px 0px 20px 0px">
                        <el-button type="danger" @click="close">取 消</el-button>
                        <el-button type="primary" @click="submitForm">保 存</el-button>
                    </div>

                </el-tab-pane>
            </el-tabs>


        </div>

        <selRole v-if="showRoleDialog"
                 :formData="form"
                 :loading="roleLoading"
                 @closeDialog="closeDialog"
                 @checkRow="checkRole">
        </selRole>
        <selAccount v-if="showAccountDialog"
                 :formData="form"
                 :loading="roleLoading"
                 @closeDialog="closeDialog"
                 @checkRow="checkAccount">
        </selAccount>
        <selWareHouse v-if="showWareHouse"
              :formData="form"
              :authKind="authKind"
              @closeDialog="closeDialog"
              @checkRow="checkWareHouse">
        </selWareHouse>

        <selProject v-if="showProject"
                      :formData="form"
                      :authKind="authKind"
                      @closeDialog="closeDialog"
                      @checkRow="checkProject">
        </selProject>
        <selDepartment v-if="showDepartment"
                    :formData="form"
                    @closeDialog="closeDialog"
                    @checkRow="checkDepartment">
        </selDepartment>
        <selProductType v-if="showProductType"
                       :formData="form"
                       @closeDialog="closeDialog"
                       @checkRow="checkProductType">
        </selProductType>
    </el-dialog>

</template>

<script>
    import selRole from './selRole'
    import selAccount from '@/components/system/account/selAccount'
    import selectTree from '@/components/tools/tree/selectTree'
    import selWareHouse from '@/components/page/stock/warehouse/selMultiple'
    import selProject from '@/components/page/project/selMultiple'
    import selDepartment from '@/components/rszy/dept/deptSelect/multiple'
    import selProductType from '@/components/page/wzgl/type/selMultiple'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selRole,selAccount, selectTree,selWareHouse,
            selProject,selDepartment,selProductType},
        data() {
            return {
                activeName: "first",
                tree_model: {
                    id: "",
                    name: ""
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },

                showRoleDialog: false,
                showAccountDialog:false,
                showWareHouse: false,
                roleLoading: false,
                showProject:false,
                showDepartment:false,
                showProductType:false,
                authKind:'',

                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
            };
        },
        async mounted() {
            await this.getDepartmentTree();
            this.tree_model = {
                id: this.formData.departmentId,
                name: this.formData.departmentName
            }
        },
        methods: {
            async getDepartmentTree() {
                this.dialoading = true;
                let param = {
                    url: "/department/listZTree",
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    const retData = data.data.jsonStr;
                    this.treeData = retData
                }
                this.dialoading = false;
            },
            closeDialog() {
                this.showRoleDialog = false;
                this.showAccountDialog = false;
                this.showWareHouse = false;
                this.showProject = false;
                this.showDepartment = false;
                this.showProductType = false;
            },
            selRoleData() {
                this.showRoleDialog = true;
            },
            checkRole() {
                this.showRoleDialog = false;
            },
            selAccountData() {
                this.showAccountDialog = true;
            },
            checkAccount() {
                this.showAccountDialog = false;
            },
            selWareHouse(kind) {
                this.authKind=kind;
                this.showWareHouse = true;
            },
            checkWareHouse(rows) {
                let warehouseId = [];
                let warehouseNo = [];
                let warehouseIdReg = [];
                let warehouseNoReg = [];
                rows.map(item=>{
                    warehouseId.push(item.warehouseId)
                    warehouseNo.push(item.warehouseNo)
                    warehouseIdReg.push(item.warehouseId)
                    warehouseNoReg.push(item.warehouseNo)
                })
                if(this.authKind===1) {
                    this.form.warehouseId = warehouseId.toString();
                    this.form.warehouseNo = warehouseNo.toString();
                }else {
                    this.form.warehouseIdReg = warehouseIdReg.toString();
                    this.form.warehouseNoReg = warehouseNoReg.toString();
                }
                this.showWareHouse = false;
            },
            deleteWareHouse(kind) {
                if(kind===1){
                    this.form.warehouseId="";
                    this.form.warehouseNo="";
                }else{
                    this.form.warehouseIdReg="";
                    this.form.warehouseNoReg="";
                }
                this.$forceUpdate();
            },
            selProject(kind) {
                this.authKind=kind;
                this.showProject = true;
            },
            checkProject() {
                this.showProject = false;
            },
            deleteProject(kind) {
                if(kind==1){
                    this.form.projectId="";
                    this.form.projectName="";
                }else{
                    this.form.projectIdReg="";
                    this.form.projectNameReg="";
                }
                this.$forceUpdate();
            },
            selProductType(){
                this.showProductType = true;
            },
            checkProductType(){
                this.showProductType = false;
            },
            deleteProductType() {
                this.form.productTypeId = "";
                this.form.productTypeName = "";
                this.$forceUpdate();
            },
            selDepartment(){
                this.showDepartment = true;
            },
            checkDepartment(){
                this.showDepartment = false;
            },
            deleteDepartment() {
                this.form.departmentIds = "";
                this.form.departmentIdsName = "";
                this.$forceUpdate();
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {

                if (this.form.newPwd != this.form.loginPwd) {
                    this.$message({message: '俩次填写的密码不一致', type: 'error'});
                    return;
                }
                this.form.departmentId = this.tree_model.id;
                this.form.departmentName = this.tree_model.name;

                if (this.$pub.isEmpty(this.form.userState)) {
                    this.$message({message: '请选择用户状态', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.loginName)) {
                    this.$message({message: '请输入登录账号', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.departmentName)) {
                    this.$message({message: '请选择部门', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.roleNames)) {
                    this.$message({message: '请选择岗位角色', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.accountNames)) {
                    this.$message({message: '请选择可登录账套', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form);
            },
        }
    }
</script>

